import React from 'react';
import '../styles/ErrorFallback.css';

interface ErrorFallbackProps {
  error: Error | null;
  resetError: () => void;
}

function ErrorFallback({ error, resetError }: ErrorFallbackProps) {
  return (
    <div className="error-fallback-container">
      <div className="error-fallback-card">
        <div className="error-fallback-icon">⚠️</div>
        <h2 className="error-fallback-title">Something went wrong</h2>
        <p className="error-fallback-message">
          We encountered an unexpected error. Don&apos;t worry, your data is
          safe.
        </p>
        {error && (
          <details className="error-fallback-details">
            <summary>Technical details</summary>
            <pre className="error-fallback-stack">{error.toString()}</pre>
          </details>
        )}
        <div className="error-fallback-actions">
          <button
            className="btn btn-primary error-fallback-retry"
            onClick={resetError}
            type="button"
          >
            Try Again
          </button>
          <button
            className="btn btn-secondary error-fallback-home"
            onClick={() => (window.location.href = '/')}
            type="button"
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorFallback;
